export interface AskAiFrameConfigData {
  ddChatBaseUrl: string;
  embedAppBaseUrl: string;
  cdnUrl: string;
}

const defaults: AskAiFrameConfigData = {
  ddChatBaseUrl: '',
  embedAppBaseUrl: '',
  cdnUrl: ''
};

// eslint-disable-next-line @typescript-eslint/no-empty-object-type, @typescript-eslint/no-empty-interface
export interface AskAiFrameConfig extends AskAiFrameConfigData {}

//Ensure this class is an exact copy of what is available in libs/ask-ai-frame/src/models/app.model.ts
export interface ChatDashboardSection {
  [key: string]: ChatDashboard;
}

//Ensure this class is an exact copy of what is available in libs/ask-ai-frame/src/models/app.model.ts
export interface ChatDashboard {
  [key: string]: string;
}

export class AskAiFrameConfig {
  constructor(json?: AskAiFrameConfigData) {
    json = json ?? defaults;

    Object.assign(this, defaults, json, {
      cdnUrl: json.cdnUrl.trim()
    });
  }
}
